import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import Link from '@mui/material/Link'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import actionTypes from 'store/actions'
import ArrowTooltip from 'components/Common/ToolTip/ArrowTooltip'
import Button from 'components/Common/Button'

import { PRIMARY_BUTTON, DISABLED_BUTTON } from 'themes/theme'

const ConnectButton = ({
  label,
  onClick,
  primary = false,
  tooltipPlacement = 'top',
  fullWidth = false,
  isConnected = true,
  ...rest
}) => {
  const navigate = useNavigate()
  const userInfo = useSelector(state => state.userReducer)
  const isFreeAccount = !primary && userInfo?.user?.accountType !== 'premium'
  const dispatch = useDispatch()

  const codatIntegrated = useSelector(state => state.apiResponseReducers.codatIntegrated)
  const accountCodatConnected = useSelector(state => state.appReducer.accountCodatConnected)
  const commerceCodatConnected = useSelector(state => state.appReducer.commerceCodatConnected)
  const companyId = useSelector(state => state.apiResponseReducers.companyId)

  const onClickTooltip = e => {
    e && e.preventDefault()
    navigate('/welcome')
    // dispatch({ type: actionTypes.TOGGLESUBSCRIPTIONMODAL, data: true })
    // dispatch({ type: actionTypes.HIDEDIALOG })
  }

  const handleConnectClick = () => {
    if (onClick) {
      onClick()

      return
    }
    handleCodat()
  }

  const handleCodat = () => {
    if (codatIntegrated) {
      if (accountCodatConnected && !commerceCodatConnected) {
        window.location.replace(`https://links.codat.io/company/${companyId}/link/commerce`)
      } else if (commerceCodatConnected && !accountCodatConnected) {
        window.location.replace(`https://links.codat.io/company/${companyId}/link/accounting`)
      } else {
        window.location.replace(`https://links.codat.io/company/${companyId}`)
      }
    } else {
      dispatch({ type: actionTypes.TOGGLECOMPANYNAMEMODAL, data: true })
    }
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
      }}
    >
      {isFreeAccount ? (
        <ArrowTooltip
          position={tooltipPlacement}
          toolTipContent={() => (
            <Box
              sx={{
                textAlign: 'center',
              }}
            >
              <Link
                underline="hover"
                sx={{ cursor: 'pointer', textDecorationColor: 'white !important' }}
                onClick={onClickTooltip}
              >
                <Typography component="span" variant="button2" color="white">
                  Click here
                </Typography>
              </Link>
              <Typography component="span" variant="body2" color="white">
                &nbsp;to become a premium member
              </Typography>
            </Box>
          )}
        >
          <Button type={DISABLED_BUTTON} fullWidth={fullWidth} onClick={handleConnectClick} {...rest}>
            {label}
          </Button>
        </ArrowTooltip>
      ) : isConnected ? (
        <Button type={PRIMARY_BUTTON} fullWidth={fullWidth} onClick={handleConnectClick} {...rest}>
          {label}
        </Button>
      ) : (
        <Button type={PRIMARY_BUTTON} fullWidth={fullWidth} onClick={handleConnectClick} {...rest}>
          {label}
        </Button>
      )}
    </Box>
  )
}

export default ConnectButton
